/* eslint-disable max-len */
import React, { useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader, Col, Row, Input, Button, Spinner } from "reactstrap";
import LaddaButton, { EXPAND_RIGHT } from "react-ladda";
import PropTypes from "prop-types";

import { SelectFormField, FormField } from "../../../utils/FormFields";
import { getISODate } from "../../../utils/dateUtils";

export function preCheckObjectEmpty(object) {
  let res = object && Object.keys(object).length > 0;
  Object.keys(object).forEach((key) => {
    if (!object[key] && object[key] !== 0 && object[key] !== false) {
      res = false;
    }
  });
  return res;
}

const ModalArchive = ({ open, onToggle, onSave, archiveType, loading }) => {
  const [newArchive, setNewArchive] = useState({
    ArchiveId: 0,
    ArchivesName: "",
    ArchivesTypeId: archiveType.ArchiveTypeId,
    ArchivesTypeDescription: archiveType.ArchiveTypeDescription,
    ArchivesSubTypeId:
      archiveType.ArchivesSubTypes[Object.keys(archiveType.ArchivesSubTypes)[0]].ArchiveSubTypeId,
    ArchivesSubTypeDescription:
      archiveType.ArchivesSubTypes[Object.keys(archiveType.ArchivesSubTypes)[0]].ArchiveSubTypeDescription,
    canBeLifelong:
      archiveType.ArchivesSubTypes[Object.keys(archiveType.ArchivesSubTypes)[0]].ArchiveSubTypeCanBeLifelong,
    hasExpiration:
      archiveType.ArchivesSubTypes[Object.keys(archiveType.ArchivesSubTypes)[0]].ArchiveSubTypeHasExpiration,
    ArchivesBlob: null,
    ArchivesExtension: "",
    ArchivesEnabled: true,
    ArchivesExpirationDate: getISODate(new Date()),
    ArchivesHasExpirationDate: true,
  });

  const onChange = (name, value) => {
    const newNewArchive = {
      ...newArchive,
      [name]: value,
    };
    if (name === "ArchivesSubTypeId") {
      Object.keys(archiveType.ArchivesSubTypes).forEach((key) => {
        const subType = archiveType.ArchivesSubTypes[key];
        if (parseInt(subType.ArchiveSubTypeId, 10) === parseInt(value, 10)) {
          newNewArchive.ArchivesSubTypeDescription = subType.ArchiveSubTypeDescription;
          newNewArchive.hasExpiration = subType.ArchiveSubTypeHasExpiration;
          newNewArchive.canBeLifelong = subType.ArchiveSubTypeCanBeLifelong;
          newNewArchive.ArchivesHasExpirationDate =
            !newNewArchive.canBeLifelong || newNewArchive.hasExpiration;
        }
      });
    } else if (name === "ArchivesEnabled") {
      newNewArchive.ArchivesEnabled = value === "true";
    } else if (name === "ArchivesHasExpirationDate") {
      newNewArchive.ArchivesHasExpirationDate = value === "true";
    }
    setNewArchive(newNewArchive);
  };

  const handleFile = (file, name, extension) => {
    const items = file.split(",");
    setNewArchive({
      ...newArchive,
      ArchivesBlob: items[1],
      ArchivesExtension: extension,
      ArchivesName: name,
    });
  };

  const handleFileInput = (event, cb = handleFile) => {
    const file = event.target.files[0];

    if (file && file.size <= 10485760) {
      const name = file.name.substring(0, file.name.lastIndexOf("."));
      const extension = file.name.substring(file.name.lastIndexOf(".") + 1, file.name.length);
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        cb(reader.result, name, extension);
      };
      reader.onerror = (error) => {
        throw error;
      };
    } else {
      alert("File is too big! (Max. 10MB)");
      event.target = null;
    }
  };

  return (
    <div>
      <Modal isOpen={open} toggle={onToggle}>
        <ModalHeader toggle={onToggle}>Append New Document</ModalHeader>
        <ModalBody>
          {archiveType ? (
            <React.Fragment>
              <Row>
                <Col>
                  <Input
                    type="select"
                    value={newArchive.ArchivesSubTypeId}
                    onChange={(e) => onChange("ArchivesSubTypeId", e.target.value)}
                  >
                    {Object.keys(archiveType.ArchivesSubTypes).map((key) => {
                      const a = archiveType.ArchivesSubTypes[key];
                      return (
                        <option key={a.ArchiveSubTypeId} value={a.ArchiveSubTypeId}>
                          {a.ArchiveSubTypeDescription}
                        </option>
                      );
                    })}
                  </Input>
                </Col>
                <Col>
                  <Input
                    type="file"
                    dataMaxSize="2048"
                    accept="application/pdf,image/png,image/jpeg"
                    onChange={handleFileInput}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <SelectFormField
                    label="Is Lifelong?: "
                    disabled={
                      !newArchive.canBeLifelong || (newArchive.canBeLifelong && !newArchive.hasExpiration)
                    }
                    value={newArchive.ArchivesHasExpirationDate}
                    name="ArchivesHasExpirationDate"
                    onChange={onChange}
                    selectItems={[
                      {
                        id: false,
                        name: "Yes",
                      },
                      {
                        id: true,
                        name: "No",
                      },
                    ]}
                    getSelectItemId={(item) => item.id}
                    getSelectItemName={(item) => item.name}
                  />
                </Col>
                <Col>
                  <FormField
                    label="Expiration Date: "
                    value={newArchive.ArchivesExpirationDate}
                    type="date"
                    disabled={!newArchive.ArchivesHasExpirationDate}
                    name="ArchivesExpirationDate"
                    onChange={onChange}
                  />
                </Col>
                <Col>
                  <SelectFormField
                    label="Is Enabled?: "
                    //disabled={!newArchive.canBeLifelong || (newArchive.canBeLifelong && !newArchive.hasExpiration)}
                    value={newArchive.ArchivesEnabled}
                    name="ArchivesEnabled"
                    onChange={onChange}
                    selectItems={[
                      {
                        id: true,
                        name: "Yes",
                      },
                      {
                        id: false,
                        name: "No",
                      },
                    ]}
                    getSelectItemId={(item) => item.id}
                    getSelectItemName={(item) => item.name}
                  />
                </Col>
              </Row>
            </React.Fragment>
          ) : (
            <Spinner />
          )}
        </ModalBody>
        <ModalFooter>
          <LaddaButton
            className="btn btn-ladda btn-primary"
            loading={loading}
            disabled={!preCheckObjectEmpty(newArchive)}
            onClick={() => onSave(newArchive)}
            data-style={EXPAND_RIGHT}
          >
            Save
          </LaddaButton>{" "}
          <Button color="secondary" onClick={onToggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

ModalArchive.propTypes = {
  open: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  archiveType: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default ModalArchive;
